import {useState} from 'react';

export default function useAccessToken() {
    function getToken() {
        return sessionStorage.getItem('token')
    }
    function saveToken(token) {
        sessionStorage.setItem('token', token);
        setToken(token);
    }
    const [token, setToken] = useState(getToken());
    return {
        token,
        setToken: saveToken,
    }
}

export function getPayloadFromAccessToken(token) {
    const payloadData = token.split(".")[1]
    const decodedPayloadData = atob(payloadData)
    return JSON.parse(decodedPayloadData)
}